export const visit = (vm, at) => {
at({ "en": { "uiAddonTeams": { "teamSelectLabelOne": "1 team selected", "teamSelectLabelMany": "{{ count }} teams selected", "selectTeams": "Select teams", "selectAll": "Select all ({{ teamName }})" } } });
};